import CryptoJS from 'crypto-js';

// =============================================================================
// SecureStorage v2 (hallazgo S2)
// -----------------------------------------------------------------------------
// Antes: `import.meta.env.VITE_APP_SECRET_KEY` (sintaxis de Vite, NO existe en
// Vue CLI) + fallback hardcodeado `'frontline-fallback-secret-key-2026'` dentro
// del bundle. Eso era ofuscación: cualquiera con el código podía descifrar todo.
//
// Ahora: la clave se genera ALEATORIAMENTE por pestaña (crypto.getRandomValues)
// y se guarda SOLO en sessionStorage (se destruye al cerrar la pestaña). El
// bundle no contiene ninguna clave estática.
//
// Nota: al cerrar la pestaña, la clave se pierde y los datos guardados quedan
// ininteligibles → sesión por pestaña (deseable para un "sistema seguro").
// =============================================================================

const SESSION_KEY_NAME = '__nx_session_key__';

function getSessionKey() {
  try {
    let key = window.sessionStorage.getItem(SESSION_KEY_NAME);
    if (!key) {
      const bytes = new Uint8Array(32);
      self.crypto.getRandomValues(bytes);
      key = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
      window.sessionStorage.setItem(SESSION_KEY_NAME, key);
    }
    return key;
  } catch (e) {
    console.error('[SecureStorage] No se pudo acceder a sessionStorage:', e);
    return null;
  }
}

export const SecureStorage = {
  setItem(key, value) {
    try {
      if (!value) return; // No guardar nulos
      const sessionKey = getSessionKey();
      if (!sessionKey) {
        console.warn('[SecureStorage] Sin clave de sesión; no se guardó:', key);
        return;
      }
      const stringValue = JSON.stringify(value);
      const encrypted = CryptoJS.AES.encrypt(stringValue, sessionKey).toString();
      localStorage.setItem(key, encrypted);
    } catch (e) {
      console.error('Error al encriptar:', e);
    }
  },

  getItem(key) {
    try {
      const encryptedValue = localStorage.getItem(key);
      if (!encryptedValue) return null;

      const sessionKey = getSessionKey();
      if (!sessionKey) {
        localStorage.removeItem(key);
        return null;
      }

      const bytes = CryptoJS.AES.decrypt(encryptedValue, sessionKey);
      const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

      // --- DIAGNÓSTICO ---
      if (!decryptedString) {
        // Clave distinta (otra pestaña/sesión) o dato corrupto: se descarta.
        console.warn('❌ Error Crítico en SecureStorage: desencriptación vacía para', key, '(otra pestaña, otra sesión o dato de una versión anterior).');
        localStorage.removeItem(key);
        return null;
      }
      // -------------------

      return JSON.parse(decryptedString);
    } catch (e) {
      // AQUÍ ESTÁ EL PROBLEMA: Vamos a ver qué error es
      console.error('❌ Error en SecureStorage.getItem:', e);

      // Opcional: Borrar el dato corrupto para evitar bucles
      localStorage.removeItem(key);
      return null;
    }
  },

  removeItem(key) {
    localStorage.removeItem(key);
  },

  clear() {
    // La clave de sesión vive en sessionStorage: al descartarla, los datos
    // cifrados de esta pestaña quedan ininteligibles para siempre (S2).
    try {
      window.sessionStorage.removeItem(SESSION_KEY_NAME);
    } catch (e) {
      /* storage no disponible: ignorar */
    }
    localStorage.clear();
  }
};